document.addEventListener('DOMContentLoaded', function () {
  var checkoutBtns = document.querySelectorAll(
    '[name="checkout"], [type="submit"][value*="Check"], a[href="/checkout"], button[name="checkout"], .cart-summary__checkout'
  );

  // === SALVA UN CAMPO COME CART ATTRIBUTE ===
  function saveFieldAsAttribute(field) {
    var match = field.name.match(/^attributes\[(.+)\]$/);
    if (!match) return Promise.resolve();
    var attrName = match[1];
    var attrs = {};
    attrs[attrName] = field.value.trim();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  // === SALVATAGGIO AUTOMATICO AL BLUR (perdita di focus) ===
  var allFields = document.querySelectorAll('.cart-custom-field__input');
  allFields.forEach(function (field) {
    field.addEventListener('blur', function () {
      if (field.value.trim()) {
        saveFieldAsAttribute(field);
      }
    });
  });

  // === VALIDAZIONE + SALVATAGGIO FINALE AL CHECKOUT ===
  function validateFields(e) {
    var fields = document.querySelectorAll('.cart-custom-field__input[required]');
    var valid = true;

    fields.forEach(function (field) {
      field.classList.remove('field-error');
      var errorEl = field.parentNode.querySelector('.cart-custom-field__error');
      if (errorEl) errorEl.classList.remove('visible');

      if (!field.value.trim()) {
        valid = false;
        field.classList.add('field-error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'cart-custom-field__error visible';
          errorEl.textContent = 'Questo campo è obbligatorio';
          field.parentNode.appendChild(errorEl);
        } else {
          errorEl.classList.add('visible');
        }
      }
    });

    if (!valid) {
      e.preventDefault();
      e.stopPropagation();
      document.querySelector('.cart-page__custom-fields').scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      return false;
    }

    // VALIDO: blocca momentaneamente il checkout, salva tutti gli attributes, poi prosegui
    e.preventDefault();
    e.stopPropagation();

    var allAttrs = {};
    document.querySelectorAll('.cart-custom-field__input').forEach(function (f) {
      var m = f.name.match(/^attributes\[(.+)\]$/);
      if (m) allAttrs[m[1]] = f.value.trim();
    });

    var targetUrl = '/checkout';
    var btn = e.currentTarget || e.target;
    if (btn && btn.href) targetUrl = btn.href;
    else if (btn && btn.closest && btn.closest('a')) targetUrl = btn.closest('a').href;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: allAttrs })
    })
      .then(function () {
        window.location.href = targetUrl;
      })
      .catch(function () {
        window.location.href = targetUrl;
      });
  }

  checkoutBtns.forEach(function (btn) {
    btn.addEventListener('click', validateFields);
  });
});
